<button
  class="toggle-button"
  [ngClass]="{ deactivated: !activated, activated: activated, dashed: dashed, colored: !!color }"
  [disabled]="disabled"
  (click)="toggle()"
  [ngStyle]="{ 'background-color': color && activated ? color : null }"
  [tooltip]="tooltip"
>
  <span class="toggle-content">
    <ng-container>
      <i *ngIf="activated" class="fas fa-check"></i>
      <i *ngIf="!activated" class="fas fa-times"></i>
    </ng-container>
    <span>{{ caption }}</span>
    <ng-container *ngIf="useWarningIcon">
      <i class="fas fa-exclamation-triangle"></i>
    </ng-container>
  </span>
</button>
